import { Vehicle } from '@/pages/auth/vehicles/Models';

/**
 * Combina a lista de veículos vinda do CBILL (`listVehicle`) com a lista
 * vinda do serviço de garagem do app (`listGarageVehicle`), retornada pela
 * API `/home-app/v1/init/userproduct`.
 *
 * Mantém a ordem (CBILL primeiro, garagem em seguida) e deduplica por placa
 * (case-insensitive) para evitar veículos repetidos caso a mesma placa apareça
 * nas duas fontes.
 *
 * Retorna `undefined` quando nenhuma das duas listas vier no payload, para
 * preservar o comportamento original em respostas mal formadas.
 */
export function mergeVehicleLists(
    listVehicle: Vehicle[] | undefined | null,
    listGarageVehicle: Vehicle[] | undefined | null,
): Vehicle[] | undefined {
    const hasAnyList = Array.isArray(listVehicle) || Array.isArray(listGarageVehicle);
    if (!hasAnyList) return undefined;

    const seenPlates = new Set<string>();
    const merged: Vehicle[] = [];

    for (const vehicle of [...(listVehicle ?? []), ...(listGarageVehicle ?? [])]) {
        const plate = String(vehicle?.plate ?? '').toUpperCase();
        if (!plate || seenPlates.has(plate)) continue;
        seenPlates.add(plate);
        merged.push(vehicle);
    }

    return merged;
}
